/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Tab_Pending_CancelInputs */

const en_settings_billing_tab_pending_cancel = /** @type {(inputs: Settings_Billing_Tab_Pending_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending Cancel`)
};

/**
* | output |
* | --- |
* | "Pending Cancel" |
*
* @param {Settings_Billing_Tab_Pending_CancelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_tab_pending_cancel = /** @type {((inputs?: Settings_Billing_Tab_Pending_CancelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Tab_Pending_CancelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_tab_pending_cancel(inputs)
});
export { settings_billing_tab_pending_cancel as "settings.billing.tab_pending_cancel" }